// extracted by css-extract-rspack-plugin
export default {"cls1":"Comment-cls1_kE7","cls2":"Comment-cls2_ekS Comment-cls1_kE7"};